import { doc, getDoc, setDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';

export interface UserProfile {
  uid: string;
  email: string;
  displayName?: string;
  photoURL?: string;
  phoneNumber?: string;
  linkedinUrl?: string;
  jobTitle?: string;
  company?: string;
  bio?: string;
  location?: string;
  website?: string;
  skills?: string;
  // any other fields you want to store
}

export const getUserProfile = async (uid: string): Promise<UserProfile | null> => {
  const userRef = doc(firestore, 'users', uid);
  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    return { uid, ...userDoc.data() } as UserProfile;
  }
  return null;
};

export const createUserProfile = async (uid: string, data: Partial<UserProfile>): Promise<void> => {
  const userRef = doc(firestore, 'users', uid);
  await setDoc(userRef, { ...data, uid }, { merge: true });
}; 